import { useCallback, useEffect } from 'react';
import * as moment from 'moment';
import { storage } from 'packages/kakapo-ui-services/factories/PersistentStorageFactory';
import { useTranslation } from 'react-i18next';

export const useWorkspaceLocale = (availableLanguages: string[], currentLanguage: string) => {
	const { i18n } = useTranslation();

	const setLocale = useCallback(
		(locale: string) => {
			const language = locale.split('_')[0];
			storage.setItem('language', language);
			i18n.changeLanguage(language);
			moment.locale(language);
		},
		[i18n],
	);
	useEffect(() => {
		// The language is stored in the database as "en_US".
		// i18n stores it as "en", so to keep things consistent we
		// need to split the language and only use the first part.
		const languageOnly = currentLanguage.split('_')[0];

		if (availableLanguages.length > 0) {
			const language =
				availableLanguages.find((locale) => locale.split('_')[0] === languageOnly) ??
				availableLanguages[0];

			setLocale(language);
		}
	}, [availableLanguages, currentLanguage, setLocale]);

	return { setLocale };
};
